<template>
  <div class="UserCenterCollectTab switch-box">
    <div
      :style="{ 'left': switchItemLeft + 'px' }"
      class="switch-item switch-item-bar"
    />
    <div
      v-for="(vo,idx) in switchVipType"
      :key="vo.label + 'switchVipType'"
      :class="[
          { 'on': idx == vipType},
          vo.iconClass
        ]"
      class="switch-item"
      @click="toggleVipType(vo,idx)"
    >
      <i class="icon"/>
      <span>{{ vo.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCenterCollectTab",
  data() {
    return {
      switchItemLeft: 3,
      index: 0
    }
  },
  props: {
    vipType: {
      type: Number | String,
      default: 0  // 0个人 、 1企业
    },
    switchVipType:{
      type: Array,
      default: ()=>[]  // 0个人 、 1企业
    }
  },
  watch: {
    vipType: {
      handler(n, o) {
        if (n) {
          // this.toggleVipType(this.switchVipType[n], n);
          n = parseInt(n)
          this.switchItemLeft = (n) * 136 + 3 * (n + 1);
        }
      },
      immediate: true
    },
    companyRecordState(n) {
      console.log('1111----11111111')
      if (n) {
        // this.toggleVipType(this.switchVipType[1], 1);

        this.switchItemLeft = (1) * 136 + 3 * (1 + 1);

      }
    }
  },
  methods: {
    toggleVipType(vo, idx) {
      this.index = idx;
      // this.vipType = idx
      this.switchItemLeft = (idx) * 136 + 3 * (idx + 1);

      this.$emit('toggleType', vo)
    }
  }
}
</script>

<style lang="scss" scoped>
.switch-box {
  display: inline-flex;
  border-radius: 14px;
  background: linear-gradient(90deg, #F5F6FA 0%, #F5F6FA 17%, #FBFBFD 100%);
  padding: 3px;
  overflow: hidden;
  //width: 278px;
  position: relative;
  margin-bottom: 12px;

  .switch-item {
    width: 136px;
    height: 50px;
    border-radius: 14px;
    margin-right: 3px;
    position: relative;
    z-index: 2;
    @include LayoutFlex(1);
    cursor: pointer;
    color: #8085A4;

    &:last-child {
      margin-right: 0;
    }

    @mixin IconItem($png){
      .icon{
        @include BgImage(16px, 16px, 'user-center/collect-record/icon_#{$png}.svg?v=2');
        margin-right: 8px;
      }
      &.on{
        .icon{
          @include BgImage(16px, 16px, 'user-center/collect-record/icon_#{$png}@active.svg?v=2');
        }
      }
    }

    &.all{
      @include IconItem('all');
    }
    &.pic{
      @include IconItem('pic');
    }
    &.package{
      @include IconItem('package');
    }
    &.topic{
      @include IconItem('topic');
    }

    &.on {
      color: $color-primary;
    }

    &.switch-item-bar {
      box-shadow: 0 2px 4px 0 rgba(10, 37, 64, 0.1);
      position: absolute;
      left: 0;
      z-index: 1;
      background: #FFFFFF;
      transition: all 0.3s ease-in;
      display: flex;
      align-items: center;
    }
  }
}
</style>
